import { createSelector } from 'reselect';

// Config
import { getSelectedCollectionPointSelector } from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import { isCollectPlusRelatedType } from '@utils/collection/getCollectPlusRelatedStores';

const collectionDatesUnavailableState = createSelector([getSelectedCollectionPointSelector], (collectionPoint) => ({
  collectionPoint,
  isCollectPlus: collectionPoint?.ownerId ? isCollectPlusRelatedType(collectionPoint?.ownerId) : false,
}));

export default collectionDatesUnavailableState;
